import React, { useState } from "react";
import MainButton from "../button";
import Card from "../card";
import MainRadioButton from "../radioButton";
import MainInput from "../input";

const WizardSelectType = ({
  selectedWizard,
  onSearchItem,
  haveSerialNumber,
  setHaveSerialNumber,
  serialNumberLoading,
}) => {
  const [serialNumber, setSerialNumber] = useState("");

  const handelSearch = async () => {
    onSearchItem(serialNumber);
  };

  const handleDisabledSearchButton = () => {
    if (serialNumberLoading) return true;
    if (haveSerialNumber) {
      return !serialNumber;
    }

    return !haveSerialNumber;
  };

  return (
    <>
      <Card
        title={selectedWizard.name}
        className={`wizard-card-item  search-serial-number`}
      >
        <section className={`${!haveSerialNumber ? "disabled" : ""} `}>
          <MainRadioButton
            checked={haveSerialNumber}
            label="adding by serial number"
            onClick={() => {
              setHaveSerialNumber(true);
            }}
          />
          <ul className={`step-container`}>
            <li> Step 1 Content the controller to a power source.</li>
            <li> Step 2 Content an Internet cable to the controller.</li>
            <li>Step 3 Enter the controller serial number in the below.</li>
          </ul>
          <section>
            <MainInput
              type="number"
              disabled={serialNumberLoading ? true : !haveSerialNumber}
              onChange={(e) => {
                setSerialNumber(e);
              }}
              value={serialNumber}
              label={"serial number"}
            />
            <span className="description-text">
              the serial number is located on the device case, usually on the
              bottom or side of the device.
            </span>
          </section>
        </section>
        <section
          className={`${haveSerialNumber ? "disabled" : ""} `}
          style={{
            marginTop: "28px",
          }}
        >
          <MainRadioButton
            checked={!haveSerialNumber}
            label="I don't have a serial number "
            onClick={() => {
              setHaveSerialNumber(false);
            }}
          />
          <section className="step-container">
            <span className="not-serial-number-description">
              Leave the serial number field blank and click next
              This will create virtual controller that you can configure and attach to an existing device.
            </span>
          </section>
        </section>

        <section className="search-button">
          <MainButton
            isDisabled={handleDisabledSearchButton()}
            onClick={handelSearch}
            text="search"
            variant="success"
          />
        </section>
      </Card>
    </>
  );
};

export default WizardSelectType;
